import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getFormattedPhoneNumber } from '../../../utils/formatPhoneUtil';

import RequirementBlock from './RequirementBlock';

const InsuredInfoBlock = ({ insured, requirement }) => (
  <RequirementBlock title="Insured Information">
    <HStack alignItems="flex-start" justifyContent="space-between" spacing={4}>
      <Box>
        <Text textStyle="bodyLg500">Insured</Text>
        <Text>{insured.insuredCompanyName}</Text>
        <Text>{insured.insuredAddress}</Text>
        <Text>{`${insured.insuredCity ? `${insured.insuredCity},` : ''} ${insured.insuredState ?? ''} ${insured.insuredZip ?? ''}`}</Text>
      </Box>

      <Box>
        <Text textStyle="bodyLg500">Contact Details</Text>
        <Text>{requirement?.contactEmail ? requirement?.contactName : insured.insuredContactName}</Text>
        <Text>{requirement?.contactEmail ?? insured.insuredEmail}</Text>
        <Text>{!requirement.contactEmail && getFormattedPhoneNumber(insured.insuredPhone)}</Text>
      </Box>
    </HStack>
  </RequirementBlock>
);

InsuredInfoBlock.propTypes = {
  insured: PropTypes.shape({
    insuredCompanyName: PropTypes.string,
    insuredAddress: PropTypes.string,
    insuredCity: PropTypes.string,
    insuredState: PropTypes.string,
    insuredZip: PropTypes.string,
    insuredContactName: PropTypes.string,
    insuredEmail: PropTypes.string,
    insuredPhone: PropTypes.string
  }),
  requirement: PropTypes.shape({
    contactEmail: PropTypes.string,
    contactName: PropTypes.string
  })
};

export default InsuredInfoBlock;
